module.exports = __webpack_public_path__ + "img/MyPCP-Enrollment-Confirmation.2a8a357d.svg";